import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import HomeIcon from '@material-ui/icons/Home';
import { Link } from "react-router-dom";
import { Constants } from 'utilities/constants';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
    root: {
        marginRight: '1rem'
    }
});

export default function Suggestion({ suggestion }) {
    const classes = useStyles();
    const href = `${Constants.Routes.EXPLORE_PROSPECTOR_ADD_PROPERTY}/${suggestion.place_id}`;
    return (
        <ListItem button component={Link} to={href} 
            onClick={() => 
                localStorage.setItem(
                    'recentSuggestion',
                    JSON.stringify(suggestion)
                )
            }
        >
            <Avatar className={classes.root}>
                <HomeIcon />
            </Avatar>
            <ListItemText primary={suggestion.description}/>
        </ListItem>
    );
}